import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom'
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';

import Typography from '@material-ui/core/Typography';

const styles = {
  description: {
      height: '100px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
  },
  cardAction: {
      display: 'block',
      width: 345,
  },
  card: {
    width: 345,
  },
  media: {
    backgroundSize: 'contain',
    objectFit: 'contain',
    width: null,
    height: 350,
    paddingTop: 15,
    backgroundColor: 'black'
  },
};

function ImageCard(props) {
  const { classes, image } = props;
    console.log(image);
  return (
    <div>
      <Card className={classes.card}>
        <ButtonBase
            className={classes.cardAction}
            onClick={event => props.history.push(`/image/${image.pk}`)}
        >
          {/*<CardHeader
                avatar={
                    <Avatar aria-label="Image" className={classes.avatar}>
                        YT
                    </Avatar>
                }
                title={image.fields.title}
            />*/}
            <CardMedia
              className={classes.media}
              image={image.fields.cloud_location}
              title={image.fields.title}
            />
            <CardContent>
              <Typography gutterBottom variant="headline" component="h2">{image.fields.title}</Typography>
              <Typography className={classes.description} component="p">{image.fields.description}</Typography>
            </CardContent>
        </ButtonBase>
                  {/*<CardActions>
          <Button size="small" color="primary">
            Renditions
          </Button>
          <Button size="small" color="primary" disabled="disabled">
            Entities
          </Button>
        </CardActions>*/}
      </Card>
    </div>
  );
}

ImageCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(ImageCard));



// WEBPACK FOOTER //
// ./src/components/image_card.jsx